// layer

export const update_ty_animation_timer_structure = (ty_timer, id, step) => {
    if (ty_timer[id].max_step < step) {
        return {
            ...ty_timer,
            [id]: {
                ...ty_timer[id],
                max_step: step,
            }
        }
    }

    return ty_timer
}

export const generate_forecast_node_class = (id, step) => {
    const loop_class = `typhoon--forecast ${id}_loop loop_step_`;
    return `${loop_class}${step}`
}

export const make_typhoon_time_marker = (options) => {
    const {
        id, feature, latlng
    } = options

    let time_text = feature.properties.data_time;
    let zIndexOffset = 1000;

    if (feature.new_day) {
        const date = feature.new_day.split(' ')[0].split('-');
        time_text = `${date[1]}-${date[2]}`
        zIndexOffset = 2000;
    }


    const typhoon_time_tag = L.divIcon({
        className: `typhoon_time_tag ${feature.class_name || ''}`,
        iconSize: L.point(40, 37),
        html: `<div class="typhoon_time ${feature.new_day ? 'new_day' : ''}">${time_text}</div>`
    });
    
    return L.marker(latlng, {
        icon: typhoon_time_tag,
        pane: id,
        zIndexOffset
    })
}

export const make_typhoon_name_tag = (options) => {
    const {
        id, 
        feature, 
        latlng,
        language,
    } = options;

    const get_typhoon_name_text = (language, feature) => {
        const typhoon_name = feature.properties.typhoon_name
        const typhoon_name_en = feature.properties.typhoon_name_en
        if (language === 'en' && typhoon_name_en) {
            return `${typhoon_name} ${typhoon_name_en}`
        }
        return typhoon_name 
    }

    const typhoon_name_text = get_typhoon_name_text(language, feature)
    const typhoon_name_tag = L.divIcon({
        className: `typhoon_name_tag${feature.class_name || ''}`,
        iconSize: L.point(40, 37),
        html: `<div class="typhoon_name">${typhoon_name_text}</div>`
    });

    const marker = L.marker(latlng, {
        icon: typhoon_name_tag,
        draggable: 'true',
        riseOnHover: true,
        pane: id,
        zIndexOffset: 1000
    })
    
    marker.on('end', () => {
        var position = marker.getLatLng();
        marker.setLatLng(position, {
            draggable: 'true'
        });
    });

    return marker
}

export const show_or_hide_typhoon_time_display = (is_show_typhoon_time) => {
    document.querySelectorAll('.typhoon_time').forEach(node => {
        node.style.display = is_show_typhoon_time ? 'block' : 'None'
    })
}

// popup
/*
    get_typhoon_name_from_popup 提供給 popup table 使用，
    原因是因為在未改架構必須兼容舊版本的情況下，API 會遇到衝突名字的問題，
    所以新版需要相對應的判斷回傳的值以區分中英文
*/

export const transform_ty_invalid_value = (value, value_to_set = '--') => {
    const invalid_values = [null, 'null']
    return invalid_values.includes(value) ? value_to_set : value
}

export const get_typhoon_name_from_popup = (popup_object) => {
    const { last_data, typhoon_name } = popup_object

    if (last_data) {
        const { typhoon_name_en } = popup_object
        let new_typhoon_name = typhoon_name
        let new_typhoon_name_en = typhoon_name_en
        if (typhoon_name.includes('TD:')) {
            new_typhoon_name = null
            new_typhoon_name_en = null
        }
        return {
            tw: transform_ty_invalid_value(new_typhoon_name, '未命名'),
            en: transform_ty_invalid_value(new_typhoon_name_en, 'NONAME')
        }
    }

    const { cwa_typhoon_name } = popup_object
    return {
        tw: transform_ty_invalid_value(cwa_typhoon_name, '未命名'),
        en: transform_ty_invalid_value(typhoon_name, 'NONAME'),
    }
}

//  product setting item
export const get_typhoon_empty_data_config = (language) => {
    return {
        status: false,
        text: language === 'en' ? '(No data) at this time' : '目前（無資料）'
    }
}
